// extracted by mini-css-extract-plugin
export default {"loadingMessage":"LoadingMessage-loadingMessage-WU8sQ"};